var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"redirect"},[_c('div',{staticClass:"title"},[_c('h3',[_vm._v("Đang chuyển trang, vui lòng đợi trong giây lát...")])]),_vm._v(" "),_c('div',{staticClass:"loading"},[_c('div',{staticClass:"el-icon-loading"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47433e90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/login/LoginCallback.vue
// module id = QqsG
// module chunks = 89